import { bigQuery } from '@fiverr-private/obs';
import { DOMAIN, SUB_DOMAIN, BI_EVENT_GROUPS, BI_EVENTS_SUB_GROUPS, BI_ACTION_TYPES } from '../constants/biConsts';

export const biPageView = (eventData) => bqEvent({ group: BI_EVENT_GROUPS.PAGE_VIEW, ...eventData });
export const biImpression = (eventData) => bqEvent({ group: BI_EVENT_GROUPS.USER_IMPRESSION, ...eventData });
export const biUserAction = (eventData) =>
    bqEvent({
        group: BI_EVENT_GROUPS.USER_ACTION,
        subGroup: BI_EVENTS_SUB_GROUPS.WEBSITE_ACTIONS,
        actionType: BI_ACTION_TYPES.CLICK,
        ...eventData,
    });
export const bqEnrichment = ({ type, group, subGroup, actionType, pageCtxId, page, gig, source, payload = {} }) => ({
    type,
    group,
    event_source: source,
    action: {
        type: actionType,
    },
    domain: {
        name: DOMAIN,
    },
    publisher: {
        domain: DOMAIN,
        sub_domain: SUB_DOMAIN,
    },
    page: {
        ctx_id: pageCtxId,
        ...(page && page),
    },
    ...(subGroup && { sub_group: subGroup }),
    ...(gig && { gig }),
    ...payload,
});

export const bqEvent = ({
    type,
    group,
    subGroup = undefined,
    pageCtxId,
    page,
    actionType = undefined,
    gig = undefined,
    source = undefined,
    payload = {},
}) => {
    const enrichment = bqEnrichment({ type, group, subGroup, actionType, pageCtxId, page, gig, source, payload });

    bigQuery.send(enrichment);
};
